export default {
  install: (app, options) => {
    // Here, `app` is the Vue app instance, you can access Vuex store using `app.config.globalProperties.$store`

    // Define your function
    const getUserId = () => {
      // Access Vuex store
      const store = app.config.globalProperties.$store;

      const userinfo = store.getters['auth/getUserInfo']
      return userinfo.pk



      // Your function logic here
      // For example, accessing state from Vuex
      // const stateValue = store.state.myModule.myState;

      // Return whatever you want
      //return stateValue;
    };

    // Make the function globally available
    app.config.globalProperties.$getUserId = getUserId;
  }
};